import React from 'react'
import PropTypes from 'prop-types'

function MobileButtons(props) {
  const { step, person, amount, verifyForm, confirmForm, goToNextStep, goToPrevStep } = props
  const fieldStep = step == 'field', timeStep = step == 'time'
  const personStep = step == 'person', paymentStep = step == 'payment'
  const showNextButton = fieldStep || timeStep
  const showBackButton = !fieldStep && !paymentStep
  const verifyButton = personStep && !person.id
  const confirmButton = personStep && person.id

  return <div className='mobile-buttons'>
    { verifyButton &&
      <button className='btn-mobile btn-next-mobile mobile-only' onClick={verifyForm}>
        Verify
      </button>
    }
    { confirmButton &&
      <button className='btn-mobile btn-next-mobile mobile-only' onClick={confirmForm}>
        Verify & Go to Payment
      </button>
    }
    { showNextButton &&
      <button className='btn-mobile btn-next-mobile mobile-only' onClick={goToNextStep}>
        Next
      </button>
    }
    { showBackButton && 
      <button className='btn-mobile btn-back-mobile mobile-only' onClick={goToPrevStep}>
        Back
      </button>
    }
  </div>
}

MobileButtons.propTypes = {
  step: PropTypes.string.isRequired,
  person: PropTypes.object.isRequired,
  verifyForm: PropTypes.func,
  confirmForm: PropTypes.func,
  goToNextStep: PropTypes.func.isRequired,
  goToPrevStep: PropTypes.func.isRequired,
}

export default MobileButtons
